import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.scss';
import Main from './Main';

const root = document.getElementById('root');
const render = (): void => {
  ReactDOM.render(<Main />, root);
};

render();
